// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import React from 'react';

export async function getRoutes() {
  const routes = {"1":{"path":"/","id":"1"},"2":{"path":"/","parentId":"1","id":"2"},"3":{"path":"/about","parentId":"1","id":"3"},"4":{"path":"/contact","parentId":"1","id":"4"}} as const;
  return {
    routes,
    routeComponents: {
'1': React.lazy(() => import(/* webpackChunkName: "p__LandingWrapper" */'@/pages/LandingWrapper.tsx')),
'2': React.lazy(() => import(/* webpackChunkName: "p__home__index" */'@/pages/home/index.tsx')),
'3': React.lazy(() => import(/* webpackChunkName: "p__about__index" */'@/pages/about/index.tsx')),
'4': React.lazy(() => import(/* webpackChunkName: "p__contact__index" */'@/pages/contact/index.tsx')),
},
  };
}
